import { LinkedIn, PictureAsPdf } from '@material-ui/icons';

export const heroInfo = {
  name: 'Anjali Pandey',
  image: '/images/Anjali.png',
  title: [
    'MBA Student',
    'Aspiring Business Analyst',
    'Finance & HR Enthusiast',
    'Management Trainee',
    'Strategic Planner',
  ],

  contacts: [
    
    {
      id: 1,
      name: 'LinkedIn',
      icon: LinkedIn,
      username: 'anjali-pandey-095947381',
      link: 'https://www.linkedin.com/in/anjali-pandey-095947381/',
    },
    {
      id: 2,
      name: 'Resume',
      icon: PictureAsPdf,
      username: 'Download Resume',
      link: '/images/resume.pdf',
      download: true,
    },
  ],
  summary: 'MBA student with strong analytical, research, and communication skills and a background in Economics and Political Science. Experienced in academic projects, case studies, and presentations, with exposure to HR, Marketing, Finance, and Operations fundamentals. Seeking an entry-level corporate role to apply business and strategic skills.',
};

export const academicExperience = [
  {
    id: 1,
    year: 'Current',
    role: 'MBA Student',
    companyName: 'Business School',
    description: 'Currently pursuing an MBA, strengthening business, managerial, and strategic competencies.',
  },
  {
    id: 2,
    year: 'Achievement',
    role: 'Ek Bharat Shreshtha Bharat',
    companyName: 'University Level',
    description: 'Participated in a university-level essay competition under the Ek Bharat Shreshtha Bharat initiative, demonstrating strong research, analytical, and writing capabilities.',
  },
  {
    id: 3,
    year: 'Achievement',
    role: '2nd Position',
    companyName: 'Essay Competition',
    description: 'Secured 2nd position among multiple participants, reflecting critical thinking and in-depth analysis of political, economic, and historical themes.',
  },
  {
    id: 4,
    year: 'Appreciation',
    role: 'Academic Performance',
    companyName: 'University',
    description: 'Received official appreciation from the university for outstanding academic performance.',
  },
  {
    id: 5,
    year: 'Certification',
    role: 'Career Guidance Session',
    companyName: 'Grad Guru Innovation (ISO-certified)',
    description: 'Successfully completed a career guidance and professional development session conducted by Grad Guru Innovation, gaining valuable insights into career planning.',
  },
];

export const educations = [
  {
    id: 1,
    year: '25/05/2025 - 2027',
    universityName: 'Siddharth University Kapilvastu',
    department: 'MBA (Master of Business Administration)',
    description: 'Currently Pursuing',
  },
  {
    id: 2,
    year: '06/2022 - 02/2025',
    universityName: 'Siddharth University Kapilvastu',
    department: 'Bachelor Of Arts (Political Science, Economics, And History)',
    description: 'Siddharth Nagar, India - 8.25 SPI',
  },
  {
    id: 3,
    year: '05/2020 - 05/2022',
    universityName: 'RP JSSMIC Tetari Bazar Siddharth Nagar',
    department: 'Senior Secondary School (Science)',
    description: 'Siddharth Nagar, India - 81%',
  },
  {
    id: 4,
    year: '05/2018 - 05/2020',
    universityName: 'RP JSSMIC Tetari Bazar Siddharth Nagar',
    department: 'Secondary School (Science)',
    description: 'Siddharth Nagar, India - 85.66%',
  },
];

export const certifications = [
  {
    id: 1,
    image: '/images/Ek-Bharat.jpg',
    name: 'Ek Bharat Shrestha Bharat Essay Competition',
    description: 'Certificate of Participation – Participated in the ‘Ek Bharat Shrestha Bharat’ Essay Competition organized by Siddharth University.',
    tools: ['Participation', 'Essay Writing'],
  },
  {
    id: 2,
    image: '/images/university.png',
    name: 'University-level Essay Competition',
    description: '2nd Rank Achievement – Secured 2nd position in the university-level Essay Competition held on 26th Sep 2022.',
    tools: ['Rank 2', 'University Level'],
  },
  {
    id: 3,
    image: '/images/university.png',
    name: 'Appreciation Certificate',
    description: 'Recognized by Siddharth University for outstanding performance and enthusiasm in the competition.',
    tools: ['Appreciation', 'Performance'],
  },
  {
    id: 4,
    image: '/images/ISO.jpg',
    name: 'Career Guidance Session',
    description: 'Successfully completed a career guidance session conducted by Grad Guru innovation (ISO certified).',
    tools: ['Career Guidance', 'ISO Certified'],
  },
];

export const skills = [
  {
    title: 'Leadership',
    logo: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png',
  },
  {
    title: 'Communication',
    logo: 'https://cdn-icons-png.flaticon.com/512/2909/2909675.png',
  },
  {
    title: 'Problem Solving',
    logo: 'https://cdn-icons-png.flaticon.com/512/3063/3063829.png',
  },
  {
    title: 'Teamwork',
    logo: 'https://cdn-icons-png.flaticon.com/512/1256/1256650.png',
  },
  {
    title: 'Strategic Planning',
    logo: 'https://cdn-icons-png.flaticon.com/512/1509/1509612.png',
  },
  {
    title: 'Microsoft Office',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg',
  },
  {
    title: 'Time Management',
    logo: 'https://cdn-icons-png.flaticon.com/512/2097/2097068.png',
  },
  {
    title: 'Public Speaking',
    logo: 'https://cdn-icons-png.flaticon.com/512/1189/1189167.png',
  },
  {
    title: 'Decision Making',
    logo: 'https://cdn-icons-png.flaticon.com/512/1534/1534938.png',
  },
  {
    title: 'Analytical Skills',
    logo: 'https://cdn-icons-png.flaticon.com/512/1541/1541416.png',
  },
  {
    title: 'Digital Marketing',
    logo: 'https://cdn-icons-png.flaticon.com/512/1998/1998087.png',
  },
  {
    title: 'Project Management',
    logo: 'https://cdn-icons-png.flaticon.com/512/1087/1087815.png',
  },
  {
    title: 'Creative Thinking',
    logo: 'https://cdn-icons-png.flaticon.com/512/2910/2910768.png',
  },
];
